import { autoinject, bindable, computedFrom } from 'aurelia-framework';
import {
	IStructureParser,
	OrganizationStructureParser
} from '../../../components/structure-import/structure-parsers/structure-parser';
import { TabService } from '../../../components/tabs/tab-service';
import { NodeModel } from '../../../models/node-model';
import { ICostCenterAM } from '../cost-centers/cost-center-api';
import { OrganizationalUnitService } from './organizational-unit-service';

@autoinject
export class OrganizationalUnitActions {
	@bindable organizationId: string;
	@bindable selectedNode: NodeModel;
	@bindable addingCostCenter: (params: any) => Promise<Response>;
	@bindable updatingCostCenter: (params: any) => Promise<Response>;
	@bindable removingCostCenter: (params: any) => Promise<Response>;

	organizationalStructureParser: IStructureParser<NodeModel[]>;

	constructor(private unitService: OrganizationalUnitService, private tabService: TabService) {
		this.organizationalStructureParser = new OrganizationStructureParser();
	}

	refreshStructure() {
		this.unitService.refreshOrganizationalUnits(this.organizationId, true);
	}

	selectedNodeChanged(newValue: NodeModel, oldValue: NodeModel) {
		const getType = (node: NodeModel) => node == null ? 'OrganizationalUnit' : node.nodeType;
		const newType = getType(newValue);
		const oldType = getType(oldValue);

		if (newType !== oldType) {
			this.tabService.select('organizational-structure', 'import');
		}
	}

	@computedFrom('selectedNode')
	get organizationalUnitName() {
		return this.selectedNode != null && this.selectedNode.nodeType === 'OrganizationalUnit'
			? this.selectedNode.title
			: '';
	}

	@computedFrom('selectedNode')
	get costCenterSelected() {
		return this.selectedNode != null && this.selectedNode.nodeType === 'CostCenter';
	}

	@computedFrom('selectedNode')
	get costCenterName() {
		return this.selectedNode != null && this.selectedNode.nodeType === 'CostCenter'
			? this.selectedNode.title
			: '';
	}

	async addCostCenter(costCenter: ICostCenterAM) {
		return await this.addingCostCenter({ costCenter });
	}

	async updateCostCenter(costCenter: ICostCenterAM) {
		return await this.updatingCostCenter({ costCenter });
	}

	async removeCostCenter(costCenter: ICostCenterAM) {
		return await this.removingCostCenter({ costCenter });
	}
}
